import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import i18n from './i18n'
import { filterInstaller } from './filters'
import Auth from './auth'
import Buefy from 'buefy'
import Form from './form'
//styles
import 'nprogress/nprogress.css'
import '@mdi/font/css/materialdesignicons.min.css'

Vue.use(Buefy)
Vue.use(filterInstaller)
Vue.use(http)
Vue.use(Auth)
Vue.use(Form)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
